import { Injectable } from '@angular/core';
import {
  InterpolatableTranslation,
  InterpolatableTranslationObject,
  isArray,
  StrictTranslation,
  TranslateCompiler,
  TranslationObject,
} from '@ngx-translate/core';

@Injectable()
export class OooCompilerService extends TranslateCompiler {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public compile(value: string, lang: string): string {
    return this.replaceToOOO(value);
  }

  public compileTranslations(translations: TranslationObject, lang: string): InterpolatableTranslationObject {
    const compiled: InterpolatableTranslationObject = {};

    for (const key in translations) {
      if (Object.prototype.hasOwnProperty.call(translations, key)) {
        const value = translations[key];
        if (typeof value === 'object' && value !== null) {
          if (isArray(value)) {
            compiled[key] = this.handleStrictTranslation(value, lang);
          } else {
            compiled[key] = this.compileTranslations(value, lang);
          }
        } else {
          compiled[key] = value ? this.compile(value, lang) : value;
        }
      }
    }

    return compiled;
  }

  private handleStrictTranslation(translations: StrictTranslation[], lang: string): InterpolatableTranslation[] {
    return translations.map(value => {
      if (typeof value === 'object' && value !== null && !isArray(value)) {
        return this.compileTranslations(value, lang);
      }

      if (isArray(value)) {
        return this.handleStrictTranslation(value, lang);
      }

      if (!value) {
        return value;
      }

      return this.compile(value, lang);
    });
  }

  private replaceToOOO(value: string): string {
    const regEx = /({{.+?}})|(<[^>]+?>)|([A-Za-z])/g;

    return value.replace(regEx, (match, expression, tag) => {
      if (tag) {
        return tag;
      }

      if (expression) {
        return expression;
      }

      return 'O';
    });
  }
}
